import useMediaQuery from "@mui/material/useMediaQuery";
import { FormItemTypes } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { EditableDataGrid } from "../../../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { Box, Card, Typography } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
export var StateWiseFailuresReported = function (props) {
    var value = props.value, onChange = props.onChange;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var columns = [{
            type: "string",
            field: "Index",
            headerName: "Sr.No",
            editable: false
        }, {
            type: "string",
            field: "State",
            headerName: "State",
            editable: false,
            flex: 1
        }, {
            type: "string",
            field: "Count",
            headerName: "Intensity",
            editable: false,
            flex: 1
        }, {
            type: "string",
            field: "Count",
            headerName: "No of FRs",
            editable: false,
            flex: 1
        }];
    var formData = [{
            type: FormItemTypes.Typography,
            name: "",
            fontSize: "md",
            fontWeight: "strong",
            children: "State wise failures reported",
            columnSize: 12,
            sx: {
                p: 0,
                m: 0
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            pt: 2,
            mb: 9,
            elements: [{
                    type: FormItemTypes.List,
                    name: '',
                    columnSize: 12,
                    variant: 'comfortable',
                    value: value === null || value === void 0 ? void 0 : value.StatewiseCount,
                    getRowHeight: function () { return 'auto'; },
                    disableCheckboxSelection: true,
                    columns: [{
                            field: 'State',
                            flex: 1,
                            renderCell: function (_ref) {
                                var row = _ref.row;
                                return /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
                                    p: 1,
                                    fontWeight: 'bold',
                                    fontSize: 'md'
                                }, row === null || row === void 0 ? void 0 : row.State), /*#__PURE__*/ React.createElement(Card, {
                                    sx: {
                                        border: 'none',
                                        boxShadow: 'none',
                                        bgcolor: 'secondary.50',
                                        p: 1,
                                        mb: 2
                                    }
                                }, /*#__PURE__*/ React.createElement(Box, {
                                    display: "flex",
                                    justifyContent: 'space-between',
                                    alignItems: "center",
                                    mb: 1
                                }, /*#__PURE__*/ React.createElement(Typography, {
                                    color: 'text.secondary'
                                }, "Intensity:"), /*#__PURE__*/ React.createElement(Typography, null, row === null || row === void 0 ? void 0 : row.Count)), /*#__PURE__*/ React.createElement(Box, {
                                    display: "flex",
                                    justifyContent: 'space-between',
                                    alignItems: "center"
                                }, /*#__PURE__*/ React.createElement(Typography, {
                                    color: 'text.secondary'
                                }, "No of FR's:"), /*#__PURE__*/ React.createElement(Typography, null, row === null || row === void 0 ? void 0 : row.Count))));
                            }
                        }]
                }]
        }];
    return lgMode ? /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: value === null || value === void 0 ? void 0 : value.StatewiseCount,
        onChange: onChange,
        disableAddRow: true,
        dataGridHeader: "State wise failures reported",
        disableDeleteRow: true,
        disableToolbarActions: true,
        isCollapsible: false,
        dataGridProps: {
            slotProps: {
                toolbar: {
                    chipLabel: null
                }
            },
            sx: {
                marginBottom: 2
            },
            hideFooter: true,
            disableColumnMenu: true,
            checkboxSelection: false
        }
    }) : /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        gridProps: {
            spacing: 0,
            p: 0
        }
    });
};
